import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const dirtyMap: { [key: string]: boolean | null } = {};

@Injectable({ providedIn: 'root' })
export class DirtyService {
  constructor() {}

  private isDirty$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );
  isDirty: Observable<boolean> = this.isDirty$.asObservable();

  setDirty(key: string, timeout?: number) {
    dirtyMap[key] = true;
    this.isDirty$.next(true);
    if (timeout)
      setTimeout(() => {
        this.clearDirty(key);
      }, timeout);
  }

  clearDirty(key: string) {
    dirtyMap[key] = null;
    if (!this.checkDirty()) this.isDirty$.next(false);
  }

  private checkDirty() {
    const isDirty = Object.keys(dirtyMap)
      .map(d => dirtyMap[d])
      .some(d => d);
    return isDirty;
  }
}
